var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIndeterminateBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_10046",
    "data-name": "Group 10046",
    transform: "translate(-14 -588)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10044",
    "data-name": "Group 10044",
    transform: "translate(-86 -357)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17707",
    "data-name": "Rectangle 17707",
    width: 16,
    height: 16,
    rx: 3,
    transform: "translate(100 945)",
    fill: "#2699fb"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_2348",
    "data-name": "Path 2348",
    d: "M-18884.52,6293.628l3.549.017,5.1-.041",
    transform: "translate(18902.195 -5697.606)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIndeterminateBlue);
export default __webpack_public_path__ + "static/media/indeterminate-blue.2864aab0.svg";
export { ForwardRef as ReactComponent };